import css from '../cms-block-title.css';

interface CMSBlockTitleProps {
  value: string;
  titleTag?: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
}

export function CMSBlockTitle({ value, titleTag = 'h2' }: CMSBlockTitleProps) {
  const TitleTag = titleTag;
  return <TitleTag className={css.title}>{value}</TitleTag>;
}
